import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-brand-black text-brand-white border-t border-brand-gray">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 pt-16 pb-8">
        {/* Big brand watermark */}
        <div className="text-center mb-12">
          <div className="text-[12vw] leading-none font-black text-white/5 select-none pointer-events-none tracking-tighter">
            DISRUPT
          </div>
        </div>
        
        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 border-t border-brand-gray pt-12 -mt-8 relative z-10">
          
          {/* Brand + tagline */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4" onClick={() => window.scrollTo(0,0)}>
              <img src="/LOGO.svg" alt="DisruptNext" className="h-10 w-auto" />
            </Link>
            <p className="font-mono text-xs text-gray-500 leading-relaxed mt-4">
              Enterprise performance marketing.<br/>
              E3 Methodology.<br/>
              Built for revenue.
            </p>
            <div className="flex gap-3 mt-6">
              {['X', 'LI', 'IG'].map((platform) => (
                <a 
                  key={platform}
                  href={`https://${platform === 'X' ? 'x.com' : platform === 'LI' ? 'linkedin.com/company' : 'instagram.com'}/disruptnext`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 border border-brand-gray flex items-center justify-center font-mono text-[10px] text-gray-500 hover:border-brand-red hover:text-brand-red transition-colors"
                >
                  {platform}
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-brand-red font-mono text-xs uppercase tracking-widest mb-6">Services</h4>
            <ul className="space-y-3 font-mono text-sm text-gray-400">
              <li><Link to="/services/performance-marketing" className="hover:text-brand-white transition-colors">Performance Marketing</Link></li>
              <li><Link to="/#arsenal" className="hover:text-brand-white transition-colors">Enterprise PPC</Link></li>
              <li><Link to="/#arsenal" className="hover:text-brand-white transition-colors">SEO Warfare</Link></li>
              <li><Link to="/#arsenal" className="hover:text-brand-white transition-colors">Conversion Optimization</Link></li>
              <li><Link to="/tools/roi-calculator" className="hover:text-brand-white transition-colors">ROI Calculator</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-brand-red font-mono text-xs uppercase tracking-widest mb-6">Company</h4>
            <ul className="space-y-3 font-mono text-sm text-gray-400">
              <li><Link to="/manifesto" className="hover:text-brand-white transition-colors">Manifesto</Link></li>
              <li><Link to="/locations" className="hover:text-brand-white transition-colors">Locations</Link></li>
              <li><Link to="/#contact" className="hover:text-brand-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* HQ */}
          <div>
            <h4 className="text-brand-red font-mono text-xs uppercase tracking-widest mb-6">Headquarters</h4>
            <div className="font-mono text-sm text-gray-400 space-y-1">
              <p>Seaport Airport Road</p>
              <p>Thrikkakara, Ernakulam</p>
              <p>Kerala, 682021</p>
              <p className="mt-4 text-brand-white">India</p>
            </div>
            <div className="mt-6 font-mono text-xs text-gray-500 space-y-1">
              <a href="mailto:hello@disruptnext.com" className="block hover:text-brand-red transition-colors">hello@disruptnext.com</a>
              <a href="tel:+919895857070" className="block hover:text-brand-red transition-colors">+91 98958 57070</a>
            </div>
          </div>
        </div>

        {/* Locations bar */}
        <div className="border-t border-brand-gray mt-12 pt-8">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 font-mono text-xs text-gray-600">
            <span className="text-gray-500 font-bold">Serving:</span>
            <Link to="/locations#india" className="hover:text-brand-red transition-colors">India</Link>
            <Link to="/locations#uae" className="hover:text-brand-red transition-colors">UAE</Link>
            <Link to="/locations#saudi" className="hover:text-brand-red transition-colors">Saudi Arabia</Link>
            <Link to="/locations#europe" className="hover:text-brand-red transition-colors">Europe</Link>
            <Link to="/locations#us" className="hover:text-brand-red transition-colors">US</Link>
            <Link to="/locations#apac" className="hover:text-brand-red transition-colors">APAC</Link>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-brand-gray mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-mono text-xs text-gray-600">
            © {new Date().getFullYear()} DisruptNext Digital. All rights reserved.
          </p>
          <p className="font-mono text-[10px] text-gray-700 uppercase tracking-widest">
            Weakness is not an option.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
